import { Routes } from '@angular/router';
import { CertificatesComponent } from './components/certificates/certificates.component';

export const CERTIFICATES_ROUTES: Routes = [
    {
        path: '',
        component: CertificatesComponent,
    },
];
